import React from 'react';
import { INFDetailFormatted } from "../../components/NFTDetail/INFTDetail";

import useGetNFTCollection from "../../data/useGetNFTCollection";
import INFTSalesList from "../../models/INFTSalesList"

import AvaPepeDetail from "./AvaPepeDetail";
import AvawareAllenDetail from "./AvawareAllenDetail";
import AVAXBrosNFTDetail from "./AVAXBrosNFTDetail";
import AvaxCatsDetail from "./AvaxCatsDetail";
import AvaxcellsDetail from "./AvaxcellsDetail";
import AvaxtarsDetail from "./AvaxtarsDetail";
import ChillAFSlothsDetail from "./ChillAFSlothsDetail";
import CryptoDappersDetail from "./CryptoDappersDetail";
import CryptoSealDetail from "./CryptoSealDetail";
import CryptoWaifusDetail from "./CryptoWaifusDetail";
import DefaultDetail from "./DefaultDetail";
import DeproApeCryptoClubDetail from "./DeproApeCryptoClubDetail";
import HatchyPocketDetail from "./HatchyPocketDetail";
import HeroesOfNFTDetail from "./HerosOfNFTDetail";
import HuskyNFTDetail from "./HuskyNFTDetail";
import LootFishDetail from "./LootFishDetail";
import NeonMonstersDetail from "./NeonMonstersDetail";
import NovaXDetail from "./NovaXDetail";
import PudgyPenguinsDetail from "./PudgyPenguinsDetail";
import SkiptNFTDetail from "./SkiptNFTDetail";
import SporeDetail from "./SporeDetail";
import NFTCollectionsList from "../../data/NFTCollectionsList"
import GeneralDetail from './GeneralDetail';
import AngryBearsDetail from './AngryBearsDetail';
import NftSoccerGamesDetail from './NftSoccerGamesDetail';
import SnowBallDetail from './SnowBallDetail';
import TinyDragonDetail from './TinyDragonDetail';
import TubbyReindeerDetail from './TubbyReindeerDetail';
import YetiSummerCollectionDetail from './YetiSummerCollectionDetail';
const a = NFTCollectionsList;


export interface INFTDetailFormater {
    detailsLoading: boolean
    tokenItem: INFTSalesList
    tokenContract: string,
    saleList: INFTSalesList[],
}

export const defaultCollection = {
    id: 'yetiswapCollection',
    tokenAddress: '0x0000000004bfef9b1a67aa4e15943824996c9761',
    name: 'YetiSwap Collection',
    category: 0,
    creatorAddress: '',
    cardFormat: "DefaultCard",
    detailFormat: "DefaultDetail",
    activityFormat: "ActivityDetail"
}

const getNFTDetail = (DetailFormat: string, props: INFDetailFormatted) => {
    switch (DetailFormat) {
        case "GeneralDetail": {
            return <GeneralDetail {...props} />
        }
        case "AngryBearsDetail": {
            return <AngryBearsDetail {...props} />
        }
        case "AvawareAllenDetail": {
            return <AvawareAllenDetail {...props} />
        }
        case "AvaPepeDetail": {
            return <AvaPepeDetail {...props} />
        }
        case "AVAXBrosNFTDetail": {
            return <AVAXBrosNFTDetail {...props} />
        }
        case "AvaxCatsDetail": {
            return <AvaxCatsDetail {...props} />
        }
        case "AvaxcellsDetail": {
            return <AvaxcellsDetail {...props} />
        }
        case "AvaxtarsDetail": {
            return <AvaxtarsDetail {...props} />
        }
        case "ChillAFSlothsDetail": {
            return <ChillAFSlothsDetail {...props} />
        }
        case "CryptoDappersDetail": {
            return <CryptoDappersDetail {...props} />
        }
        case "CryptoSealDetail": {
            return <CryptoSealDetail {...props} />
        }
        case "CryptoWaifusDetail": {
            return <CryptoWaifusDetail {...props} />
        }
        case "DeproApeCryptoClubDetail": {
            return <DeproApeCryptoClubDetail {...props} />
        }
        case "HatchyPocketDetail": {
            return <HatchyPocketDetail {...props} />
        }
        case "HeroesOfNFTDetail": {
            return <HeroesOfNFTDetail {...props} />
        }
        case "HuskyNFTDetail": {
            return <HuskyNFTDetail {...props} />
        }
        case "LootFishDetail": {
            return <LootFishDetail {...props} />
        }
        case "NeonMonstersDetail": {
            return <NeonMonstersDetail {...props} />
        }
        case "NftSoccerGamesDetail": {
            return <NftSoccerGamesDetail {...props} />
        }
        case "NovaXDetail": {
            return <NovaXDetail {...props} />
        }
        case "PudgyPenguinsDetail": {
            return <PudgyPenguinsDetail {...props} />
        }
        case "SkiptNFTDetail": {
            return <SkiptNFTDetail {...props} />
        }
        case "SporeDetail": {
            return <SporeDetail {...props} />
        }
        case "SnowBallDetail": {
            return <SnowBallDetail {...props} />
        }
        case "TinyDragonDetail": {
            return <TinyDragonDetail {...props} />
        }
        case "TubbyReindeerDetail": {
            return <TubbyReindeerDetail {...props} />
        }
        case "YetiSummerCollectionDetail": {
            return <YetiSummerCollectionDetail {...props} />
        }
        case "DefaultDetail":
        default: {
            return <DefaultDetail {...props} />
        }
    }
}

export default function NFTDetailFormater({ tokenItem, detailsLoading, tokenContract, saleList }: INFTDetailFormater): JSX.Element {
    const foundedCollection: any = useGetNFTCollection(tokenContract);

    return getNFTDetail(foundedCollection ? foundedCollection.detailFormat : defaultCollection.detailFormat, { tokenItem, detailsLoading, saleList, collection: foundedCollection ?? defaultCollection });
}
